








































import {
  IBudget,
  ICouponMessage,
  IResponseGetBudget,
} from "@/vuex/modules/coupon/interfaces";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";

import DialogCoupon from "./DialogCoupon.vue";

@Component({
  components: {
    DialogCoupon,
  },
})
export default class FormBudget extends Vue {
  overlay = false;
  dialog = false;

  couponMessage: ICouponMessage = {
    title: "",
    body: "",
  };

  @Action("loadBudget", { namespace: "coupon" })
  loadBudget!: (idBudget: string) => Promise<IResponseGetBudget>;

  @Getter("getBudget", { namespace: "coupon" }) budget!: IBudget;

  public formatBudgetId(): void {
    const budgetId = this.budget.id.toString();
    this.budget.id = budgetId.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°'-,. "]+/i,
      ""
    );
  }

  public async getBudget(): Promise<void> {
    if (this.budget.id != "") {
      this.overlay = !this.overlay;
      await this.loadBudget(this.budget.id).then(
        (response: IResponseGetBudget) => {
          if (response.success) {
            this.overlay = !this.overlay;
          } else {
            this.overlay = !this.overlay;
            this.couponMessage = response.couponMessage;
            this.dialog = true;
          }
        }
      );
    }
  }

  _isSubmit(e:any){
    if (e.keyCode === 13) {
      this.getBudget()
    }
  }

  public closeDialog(): void {
    this.dialog = false;
  }
}
